// import api from "./api";

// const ContractService = {
//   getAll: () => api.get("/contracts"),
//   getById: (id) => api.get(`/contracts/${id}`),
//   create: (data) => api.post("/contracts", data),
//   update: (id, data) => api.put(`/contracts/${id}`, data),
//   sign: (id) => api.post(`/contracts/${id}/sign`),
//   cancel: (id) => api.post(`/contracts/${id}/cancel`),
// };

// export default ContractService;

import HttpService from "./htttp.service";

class ContractService {

    getAll = async () => {
        return await HttpService.get("/contracts");
    };


    getById = async (id) => {
        return await HttpService.get(`/contracts/${id}`);
    };


    create = async (data) => {
        return await HttpService.post("/contracts", data);
    };


    update = async (id, data) => {
        return await HttpService.patch(`/contracts/${id}`, data);
    };

    delete = async (id) => {
        return await HttpService.delete(`contracts/${id}`);
    };

    sign = async (id) => {
        return await HttpService.post(`contracts/${id}/sign`);
    };

    cancel = async (id) => {
        return await HttpService.post(`contracts/${id}/cancel`);
    };

    getByEvent = async (eventId) => {
        return await HttpService.get(`/contracts/event/${eventId}`);
    };

}

export default new ContractService();

